// All Salumi Tucson editorial photographs.
// To add more, drop them into /frontend/public/media/photos/ and append below.

export const GALLERY_PHOTOS = Array.from({ length: 33 }, (_, i) => {
  const n = String(i + 1).padStart(2, "0");
  return `/media/photos/salumi-photo-${n}.jpg`;
});

// A curated subset for homepage / smaller modules.
export const HOME_GALLERY_PHOTOS = [
  "/media/photos/salumi-photo-03.jpg",
  "/media/photos/salumi-photo-08.jpg",
  "/media/photos/salumi-photo-14.jpg",
  "/media/photos/salumi-photo-19.jpg",
  "/media/photos/salumi-photo-22.jpg",
  "/media/photos/salumi-photo-27.jpg",
  "/media/photos/salumi-photo-30.jpg",
  "/media/photos/salumi-photo-11.jpg",
  "/media/photos/salumi-photo-25.jpg",
  "/media/photos/salumi-photo-17.jpg",
  "/media/photos/salumi-photo-05.jpg",
  "/media/photos/salumi-photo-32.jpg",
];
